"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetConnectionInstance = exports.NetConnectionWithNetSchema = exports.NetConnectionSchema = void 0;
const zod_1 = require("zod");
const ProjectDataTypeInstance_1 = require("./ProjectInstances/ProjectDataTypeInstance");
exports.NetConnectionSchema = zod_1.z.object({
    moduleRef: zod_1.z.string(),
    moduleName: zod_1.z.string(),
    pinRef: zod_1.z.string(),
    pinFunction: zod_1.z.string().optional(),
});
exports.NetConnectionWithNetSchema = exports.NetConnectionSchema.extend({
    netName: zod_1.z.string(),
});
class NetConnectionInstance extends ProjectDataTypeInstance_1.ProjectDataTypeInstance {
    constructor(context, opts) {
        super(context);
        this.moduleRef = opts.moduleRef;
        this.moduleName = opts.moduleName;
        this.pinRef = opts.pinRef;
        this.pinFunction = opts.pinFunction;
    }
    toJSON() {
        return {
            moduleRef: this.moduleRef,
            moduleName: this.moduleName,
            pinRef: this.pinRef,
            ...(this.pinFunction ? { pinFunction: this.pinFunction } : {}),
        };
    }
}
exports.NetConnectionInstance = NetConnectionInstance;
//# sourceMappingURL=nets.js.map